import React from 'react';
import Survey, { CssNames } from '../../Survey';
import Big5Survey from './big_5_rating_10';
import BigFiveWrapper from './bigfive.styles';

class BigFiveMobileSurvey extends React.Component {
  _times = {};
  // state = { stage: 0, big5: null, matrix: null };
  //Define a callback methods on survey complete

  onComplete = async (survey, options) => {
    // Write survey results into database
    // console.log('Survey results: ');
    // const { data } = survey;
    // console.log(data);
    // await this.setState(prev => ({ big5: data, stage: prev.stage + 1 }));
    // console.log('Survey results:');
    const { data } = survey;
    console.log({ data, times: this._times });
    const { onComplete } = this.props;
    const parsed = { ...data, ...this._times };
    await onComplete(parsed);
  };

  // checkTimer = async survey => {
  //   console.log({ survey });
  //   const { maxTimeToFinish, timeSpent, currentPage } = survey;
  //   console.log({ timeSpent });
  //   // // console.log({ maxTimeToFinish, timeSpent });
  //   // if (timeSpent >= maxTimeToFinish) {
  //   //   await this.setState({ timeAvailable: false });
  //   //   await this.onComplete(survey);
  //   // }
  // };

  toNextPage = async () => {
    await this.setState(prevState => ({
      ...prevState,
      innerState: prevState.innerState + 1
    }));
  };

  onValidate = async survey => {
    // console.log('validating');
    // console.log({ survey });
    // const { currentPage, data, timeSpent } = survey;
    const { currentPage } = survey;
    // console.log({ currentPage, data, timeSpent });
    // console.log({ totSpent: timeSpent, pageSpent: currentPage.timeSpent });
    const { questions } = currentPage;
    // have to check question position survey by survey
    const currentQuestion = questions.length > 2 ? questions[2] : questions[1];
    // const { name, value } = currentQuestion;
    const { name } = currentQuestion;
    const qstName = `${name}_TIME`;
    const qstTime = currentPage.timeSpent;
    console.log({ qstName, qstTime });

    this._times = { ...this._times, [qstName]: qstTime };
  };

  render() {
    const Big5Model = new Survey.Model(Big5Survey);
    Big5Model.startTimer();
    return (
      <BigFiveWrapper>
        {/* <div className="edu_header">
          <img
            className="edu-logo"
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564630271/uaimetrics/uai_white.png"
            alt="edu-logo"
          />
        </div> */}
        <Survey.Survey
          model={Big5Model}
          css={CssNames}
          onComplete={this.onComplete}
          // onTimer={this.checkTimer}
          onValidatedErrorsOnCurrentPage={this.onValidate}
          // onCurrentPageChanging={this.onPageChange}
          // onValueChanged={this.onValueChange}
        />
        <div className='Footer'>
          {/* <img
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629089/uaimetrics/Logo_edu-corporate-2.png"
            alt="edu-corporate"
          /> */}
          {/* <img
            className="btg-logo"
            src="https://res.cloudinary.com/dpveipnvx/image/upload/v1564629090/uaimetrics/BTG-Pactual-HP_Logo.jpg"
            alt="btg-pactual"
          /> */}
        </div>
        <div className='PushStickyFooter'></div>
        <div className='Plug'>
          <a
            href='http://www.edumetrics.cl/'
            target='_blank'
            rel='noopener noreferrer'
          >
            EduMetrics
          </a>
        </div>
      </BigFiveWrapper>
    );
  }
}

export default BigFiveMobileSurvey;
